<template>
  <v-card flat text class="view-filter">
    <v-card-actions>
      <v-btn
        width="100%"
        color="primary"
        depressed
        :disabled="!hasFilters"
        @click="resetFilter"
      >filter zurücksetzen</v-btn>
    </v-card-actions>
    <v-card-text>
      <v-row v-for="filterQuestion in filterQuestions" :key="filterQuestion.form_label">
        <FilterQuestion
          :question="filterQuestion"
        />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import FilterQuestion from './FilterQuestion'

export default {
  name: 'FilterOverlay',
  components: { FilterQuestion },
  computed: {
    filterQuestions () {
      return this.$store.getters.filterQuestions
    },

    hasFilters () {
      return !!this.$store.getters.hasActiveFilter
    }
  },

  methods: {
    resetFilter () {
      this.$store.commit('clearFilterAnswers')
    }
  }
}
</script>

<style lang="scss">
  .view-filter {
    .v-select {
      font-weight: normal;

      .v-input__control {
        .v-input__slot {
          background-color: #eee;
        }
        fieldset {
          border-color: transparent !important;
        }
      }
    }
  }
</style>
